import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
	mutation Login($email: String!, $password: String!) {
		login(email: $email, password: $password) {
			status
			response
			error
		}
	}
`

export const REGISTER_MUTATION = gql`
	mutation CreateUser($name: String!, $alias: String!, $university: String!, $email: String!, $password: String!) {
		createUser(name: $name, alias: $alias, university: $university, email: $email, password: $password) {
			status
			response
			error
		}
	}
`

export const REQUEST_PASSWORD_RESET_MUTATION = gql`
	mutation RequestPasswordReset($email: String!) {
		requestPasswordReset(email: $email) {
			status
			response
			error
		}
	}
`;

export const RESET_PASSWORD_MUTATION = gql`
	mutation ResetPassword($token: String!, $newPassword: String!) {
		resetPassword(token: $token, newPassword: $newPassword) {
			status
			response
			error
		}
	}
`;

export const CURRENT_USER = gql`
	query CurrentUser {
		currentUser {
			userid
			name
			alias
			email
			phone
			balance
			learnstage
		}
	}
`

export const GET_UNIVERSITIES = gql`
	query GetUniversities {
		getUniversities
	}
`

export const CHANGE_STAGE = gql`
    mutation ChangeStage($userid: ID!, $stage: Int!) {
        changeStage(userid: $userid, stage: $stage) {
            status
            response
            error
        }
    }
`

